import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setTokenGetter } from '../utils/axios';

const AxiosProvider = ({ children }) => {
  const { getToken } = useAuth();

  useEffect(() => {
    // Set the token getter function for axios interceptor
    setTokenGetter(getToken);

    // Cleanup on unmount
    return () => {
      setTokenGetter(null);
    };
  }, [getToken]);

  return children;
};

export default AxiosProvider;
